// @core/api/endpoints/form/close_form.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CloseFormRequest,
  FormResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Close form
 * Closes a form manually. No new submissions are accepted.
 */
export async function CloseForm(
  form_id: string,
  data: CloseFormRequest,
  options?: RequestOptions
): Promise<FormResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id/close`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.post<FormResponse>(requestPath, data, requestOptions);
}
